var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13C6.141 13 3 16.14 3 20C3 20.552 3.447 21 4 21C4.553 21 5 20.552 5 20C5 17.243 7.243 15 10 15C12.757 15 15 17.243 15 20C15 20.552 15.447 21 16 21C16.553 21 17 20.552 17 20C17 16.14 13.859 13 10 13ZM8 7C8 8.103 8.897 9 10 9C11.103 9 12 8.103 12 7C12 5.897 11.103 5 10 5C8.897 5 8 5.897 8 7ZM6 7C6 4.794 7.794 3 10 3C12.206 3 14 4.794 14 7C14 9.206 12.206 11 10 11C7.794 11 6 9.206 6 7ZM22 7C22 7.55 21.55 8 21 8H20V9C20 9.55 19.55 10 19 10C18.45 10 18 9.55 18 9V8H17C16.45 8 16 7.55 16 7C16 6.45 16.45 6 17 6H18V5C18 4.45 18.45 4 19 4C19.55 4 20 4.45 20 5V6H21C21.55 6 22 6.45 22 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPlus);
export default __webpack_public_path__ + "static/media/person-plus.76fa229e80d01b5d844b287d56a84eb8.svg";
export { ForwardRef as ReactComponent };